<template>
    <div class="z-0 hidden lg:flex absolute scale-75 -ml-60 -mt-16">
        <img src="@/assets/icon/circle-rotate.svg" alt="">
    </div>
    <div class="grid font-sans">
        <div class="z-0 flex rounded-lg h-auto w-56 bg-white text-ungu shadow-tabungan">
            <div class="grid pl-8 justify-items-start">
                <p class="pt-4 font-semibold">Tabungan</p>
                <li @click="changeMenu(0)" class="duration-200 ease-in-out"
                    :class="section === 0 ? 'p-2 bg-birulangitmaluku rounded-lg text-blue-maluku font-semibold cursor-pointer' : 'p-2 text-biru cursor-pointer'">
                    Tabungan Mutiara</li>
                <li @click="changeMenu(1)" class="duration-200 ease-in-out"
                    :class="section === 1 ? 'p-2 bg-birulangitmaluku rounded-lg text-blue-maluku font-semibold cursor-pointer' : 'p-2 text-biru cursor-pointer'">
                    Tabungan Simpeda</li>
                <li @click="changeMenu(2)" class="duration-200 ease-in-out"
                    :class="section === 2 ? 'p-2 bg-birulangitmaluku rounded-lg text-blue-maluku font-semibold cursor-pointer' : 'p-2 text-biru cursor-pointer'">
                    Tabunganku</li>
                <li @click="changeMenu(3)" class="duration-200 ease-in-out"
                    :class="section === 3 ? 'p-2 bg-birulangitmaluku rounded-lg text-blue-maluku font-semibold cursor-pointer' : 'p-2 text-biru cursor-pointer'">
                    Tabungan Simpel</li>
                <li @click="changeMenu(4)" class="duration-200 ease-in-out"
                    :class="section === 4 ? 'p-2 bg-birulangitmaluku rounded-lg text-blue-maluku font-semibold cursor-pointer' : 'p-2 text-biru cursor-pointer'">
                    Deposito</li>
                <li @click="changeMenu(5)" class="duration-200 ease-in-out"
                    :class="section === 5 ? 'p-2 bg-birulangitmaluku rounded-lg text-blue-maluku font-semibold cursor-pointer' : 'p-2 text-biru cursor-pointer'">
                    Giro</li>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from "@vue/reactivity";

export default {
    setup() {
        const section = ref(0);
        const changeMenu = (id) => {
            if (section.value !== id) section.value = id;
        };
        return { section, changeMenu };
    },
};
</script>